import { render, staticRenderFns } from "./platform_chart.vue?vue&type=template&id=b7854f9c&scoped=true"
import script from "./platform_chart.vue?vue&type=script&lang=ts"
export * from "./platform_chart.vue?vue&type=script&lang=ts"
import style0 from "./platform_chart.vue?vue&type=style&index=0&id=b7854f9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7854f9c",
  null
  
)

export default component.exports